import { apiFetch } from '../client';
import Cookies from 'js-cookie';

export function getShapeInfo(geojson) {
    return apiFetch('/map-api-data/', {
        method: 'POST',
        body: JSON.stringify(geojson)
    })
}

export function fetchGeojsonData(geojson){
    return apiFetch('/map-api/divide-and-data-only/',{
        method: 'POST',
        body:JSON.stringify(geojson)
    })
}

export function forestAgencyFellingBuffer(geom){
    return apiFetch('/forestagency/finalfelling-application/buffer/',{
        method: 'POST',
        body: JSON.stringify({geom:geom})
    })
}

export function uploadAdFile(fileFormData) {
  return apiFetch('/auctions-api/file/', {
    method: 'POST',
    body: fileFormData,
    headers: {
      'Accept': 'application/json'
    }
  });
}
export function createAdAttachment(fileData, id) {
  return apiFetch('/auctions-api/auctionsattachment/', {
    method: 'POST',
    body: JSON.stringify({
      ad: parseInt(id),
      file: fileData.id
    }),
  });
}


export function deleteAdAttachmentsNew(file_id){
    let url="/auctions-api/auctionsattachment/"
    return apiFetch(url + file_id.toString() + "/",{
        method: 'DELETE'
    })
}

export function adApiRequest(method = 'GET',ad_id, data = null) {
  const headers = { 'Content-Type': 'application/json', 'X-CSRFToken': Cookies.get('csrftoken') };
  const options = {
    method: method,
    credentials: 'same-origin',
    headers: headers
  };

  if (data) {
    options.body = JSON.stringify(data);
  }

  return apiFetch(`/auctions-api/auctions/${ad_id}/`, options);
};
export function sendAdForReview(url){
    return apiFetch(url,{
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: "review=1"
    })
}

export function bookmarkAd(url){
    return apiFetch(url,{
        method: "POST",
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: "bookmarked=1",
    })
}

// Bids api
export function createSimpleBidNew(comments, files, ad_id){
    const formData = new FormData();
    files.forEach((file) => {
        formData.append('attachments', file);
    });
    formData.append("comments", comments)
    formData.append("ad_id", ad_id)

    return apiFetch("/bid-api/simple/", {
        method:"POST",
        body: formData,
        headers: {
            'X-CSRFToken': Cookies.get('csrftoken'), // REQUIRED manually
        },
    })
}

export function selectWinningBidNew(bid_id){
    return apiFetch("/bid-api/select-winner/", {
        method:"POST",
        credentials: 'same-origin',
        body: JSON.stringify({"ad_id": Window.react_data.ad.id, "bid_id": bid_id})
    })
}
